module.exports = __webpack_public_path__ + "static/media/xiang.40f842cc.jpg";